import { useState, useEffect, useContext } from "react";
import { useSearchParams } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";

const VerifyCoinbase = () => {
    const {etradeAuthCallback, holdingsData, getOrderData, accountsSummary, getWatchLists, preformanceData, userData, handleCloseEtradeAuth} = useContext(AuthContext)
    const [loading, setLoading] = useState(true);
    const [searchParams] = useSearchParams();
    const navigate = useNavigate(); 

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            const verifier = searchParams.get("code");
    
            try {
                const response = await etradeAuthCallback('coinbase', verifier, '', '');
                if (response.message === 'Authorization successful! You can now make API calls.') {
                    localStorage.setItem('coinAccessToken', response.token.access_token);
                    setLoading(false);
                    handleCloseEtradeAuth(); // Close the ETradeAuthorization popup
                    navigate('/Home/Landing');
                    
                    await holdingsData('coinbase');
                    await getOrderData('coinbase');
                    await getWatchLists('coinbase');
                    await preformanceData('coinbase', userData?.integrations?.trade_account_id, '1D');
                    await accountsSummary('coinbase');
                }
            } catch (error) {
                console.log('Failed to login', error);
            }
        };
    
        fetchData(); // Call the async function
    
        // No cleanup function needed
    }, []); 
    

    return (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
            {loading ? (
                <div className="loaderContainerStyle">
                    <div className="loaderStyle"></div>
                    <div className="textStyle">Redirecting to the Homepage ...</div>
                </div>
            ) : (
                <h2>Data Loaded</h2>
            )}
        </div>
    );
};

export default VerifyCoinbase;
